import { ComponentProps } from 'react';

import circles from './assets/circles.svg';
import circlesFilled from './assets/circles-filled.svg';
import circlesFilledBigSize from './assets/circles-filled-big-size.svg';
import { StyledImageContainer } from './styled';

type StyledImageContainerProps = ComponentProps<typeof StyledImageContainer>;

export const BgImage = {
  circles: (props: StyledImageContainerProps) => (
    <StyledImageContainer {...props}>
      <img src={circles} alt="circles" />
    </StyledImageContainer>
  ),
  circlesFilled: (props: StyledImageContainerProps) => (
    <StyledImageContainer {...props}>
      <img src={circlesFilled} alt="circles filled" />
    </StyledImageContainer>
  ),
  circlesFilledBigSize: (props: StyledImageContainerProps) => (
    <StyledImageContainer {...props}>
      <img src={circlesFilledBigSize} alt="circles filled big size" />
    </StyledImageContainer>
  ),
};
